import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ApplicationSettingsModel } from '../../../application-settings.model';
import { AppTextService } from '@fi-shared/app-text';
import { CustomButtonModel } from '@fi-app/core/custom-button.model';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';

@Component({
    selector: 'fi-role-rights-card',
    template: `
        @for (key of roleApplicationSettingGroupsKeys; track key) {
          <div
            class="role-rights-wrapper"
            [ngClass]="{ mobile: isMobilePhone() }"
            >
            <fi-role-application-setting
              [isEditMode]="isEditMode"
              [key]="key"
              [roleApplicationSettingGroups]="roleApplicationSettingGroups"
              [tooltipText]="getTooltipText()"
              >
            </fi-role-application-setting>
          </div>
        }
        
        @for (customButton of customButtons; track customButton) {
          <div
            class="role-rights-wrapper"
            [ngClass]="{ mobile: isMobilePhone() }"
            >
            <fi-role-custom-button
              [isEditMode]="isEditMode"
              [customButton]="customButton"
              [tooltipText]="getTooltipText()"
              >
            </fi-role-custom-button>
          </div>
        }
        `,
    styleUrls: ['./role-rights-card.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-role-rights-card' },
    standalone: false,
})
export class RoleRightsCardComponent {
    @Input() roleApplicationSettingGroups: {
        [key: string]: ApplicationSettingsModel[];
    };
    @Input() roleApplicationSettingGroupsKeys: string[] = [];
    @Input() customButtons: CustomButtonModel[] = [];
    @Input() isEditMode: boolean;

    constructor(
        private appTextService: AppTextService,
        private detectDevicesService: DetectDevicesService,
    ) {}

    isMobilePhone(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    getTooltipText(): string {
        return this.appTextService.get('role.adjust_rights');
    }
}
